import { Alert, Button, Card, CardHeader } from '@mui/material';

import { CreditCard, Plan } from '@localstack/types';

import { CreditCardsList } from '../../../account/CreditCardsList';

interface PaymentElementProps {
  isCardRequired: boolean;
  showCardForm: boolean;
  filteredCards: CreditCard[];
  card: Optional<CreditCard>;
  setCard: (card: CreditCard) => void;
  onDeleteCard?: (card: CreditCard) => unknown;
  renderCardForm?: (currency: string) => JSX.Element;
  plan: Plan;
  onToggleCardForm?: () => unknown;
}

export const PaymentElement = ({
  isCardRequired,
  showCardForm,
  filteredCards,
  card,
  setCard,
  onDeleteCard,
  renderCardForm,
  plan,
  onToggleCardForm,
}: PaymentElementProps): JSX.Element => {
  return (
    <Card>
      <CardHeader title="Payment Method" />
      {isCardRequired ? (
        <>
          {!showCardForm && (
            <CreditCardsList
              selectable
              cards={filteredCards}
              selected={card}
              onSelect={setCard}
              onDelete={onDeleteCard}
            />
          )}
          {showCardForm && renderCardForm && renderCardForm(plan.currency)}
          <Button fullWidth color="primary" variant="text" onClick={onToggleCardForm}>
            {showCardForm ? 'Cancel' : 'Add +'}
          </Button>
        </>
      ) : (
        <Alert severity="info">No payment method required</Alert>
      )}
    </Card>
  );
};
